// The moment the preview arrives: a check that pops in with a small burst,
// what was worked out from the reader's chart, and the two-step path that
// shows the free preview as done and the full report as the next step.

// Where each spark flies to, in px from the badge centre.
const SPARKS = [[0, -38], [33, -19], [33, 19], [0, 38], [-33, 19], [-33, -19]];

/** What the preview worked out, as short "done" lines. */
export function unlockedItems(majorPeriods) {
  const periods = majorPeriods?.periods || [];
  const now = majorPeriods?.now || "";
  const current = periods.find((p) => p.start <= now && now < p.end);
  return [
    "Birth chart calculated",
    periods.length ? `${periods.length} major periods mapped` : null,
    current ? `You're in your ${current.lord} period` : null,
  ].filter(Boolean);
}

export default function PreviewUnlocked({ majorPeriods }) {
  return (
    <div className="space-y-4">
      <div className="relative mx-auto h-14 w-14" aria-hidden="true">
        {SPARKS.map(([dx, dy], i) => (
          <span key={i}
            className="absolute left-1/2 top-1/2 -ml-1 -mt-1 h-2 w-2 rounded-full bg-orange-400 opacity-0 motion-safe:animate-spark"
            style={{ "--dx": `${dx}px`, "--dy": `${dy}px`, animationDelay: `${150 + i * 25}ms` }} />
        ))}
        <span className="grid h-14 w-14 place-items-center rounded-full bg-gradient-to-br from-orange-400 to-orange-600 text-2xl font-bold text-white shadow-lg shadow-orange-200 motion-safe:animate-pop-in">
          ✓
        </span>
      </div>

      <ul className="flex flex-wrap justify-center gap-2">
        {unlockedItems(majorPeriods).map((item) => (
          <li key={item} className="rounded-full bg-green-50 px-3 py-1 text-xs font-medium text-green-800 ring-1 ring-green-200">
            <span aria-hidden="true">✓ </span>{item}
          </li>
        ))}
      </ul>

      <ol className="flex items-center gap-2 text-xs font-medium" aria-label="Your reading, step 1 of 2 done">
        <li className="flex items-center gap-1.5 text-green-700">
          <span aria-hidden="true" className="grid h-5 w-5 place-items-center rounded-full bg-green-600 text-[11px] text-white">✓</span>
          Free preview
        </li>
        <li aria-hidden="true" className="h-0.5 flex-1 rounded-full bg-gradient-to-r from-green-500 to-orange-200" />
        <li className="flex items-center gap-1.5 text-gray-500">
          <span aria-hidden="true" className="grid h-5 w-5 place-items-center rounded-full border-2 border-orange-300 bg-white text-[10px] text-orange-500">2</span>
          Full report
        </li>
      </ol>
    </div>
  );
}
